export const translations = {
  en: {
    "actions.call": "Call",
    "actions.close": "Close",
    "actions.directions": "Directions",
    "actions.exploreNearbyVenues": "Explore nearby venues",
    "actions.menu": "Menu",
    "actions.officialInfo": "Official info",
    "actions.viewAllServices": "View all services",
    "actions.viewVenue": "View venue",
    "actions.website": "Website",
    "common.loading": "Loading...",
    "common.pageNotFound": "Page not found",
    "footer.analytics": "We collect anonymous usage data to improve Vibe2Nite. No personal identifiable data is sold.",
    "footer.copyright": "© 2026 Vibe2Nite. All rights reserved. Martin Maughan",
    "footer.disclaimer": "Disclaimer",
    "footer.poweredBy": "Powered by",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "hotel.barsNearby": "Bars nearby",
    "hotel.beachBars": "Beach bars",
    "hotel.demoEyebrow": "Demo preview by Vibe2Nite",
    "hotel.familyFriendly": "Family-friendly options",
    "hotel.findTheVibe": "Find the vibe. Go tonight.",
    "hotel.liveMusicNightlife": "Live music / nightlife",
    "hotel.nearbyRestaurants": "Nearby restaurants",
    "hotel.nightlife": "Nightlife",
    "hotel.travel.busOrTaxi": "Bus or taxi recommended from {hotel}",
    "hotel.travel.notWalkable": "Not recommended on foot from {hotel}",
    "hotel.travel.shortWalk": "Short walk from {hotel}",
    "hotel.travel.taxiRecommended": "Taxi recommended from {hotel}",
    "hotel.travel.walkable": "Walkable from {hotel}",
    "hotel.venuesCouldNotLoad": "Venues could not be loaded right now.",
    "hotel.vibe2nitePick": "Vibe2Nite Pick",
    "hotel.visitVibe2Nite": "Visit Vibe2Nite",
    "language.label": "Language",
    "nav.awards": "Awards",
    "nav.destinations": "Destinations",
    "nav.food": "Food",
    "nav.home": "Home",
    "nav.map": "Map",
    "nav.usefulServices": "Useful Services",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Airport",
    "services.bus": "Bus",
    "services.emergency": "Emergency",
    "services.markets": "Markets",
    "services.medical": "Medical",
    "services.pharmacy": "Pharmacy",
    "services.taxi": "Taxi",
    "services.tourist-info": "Tourist Info",
    "services.train": "Train",
    "services.weather": "Weather",
    "services.homeEyebrow": "Useful Services",
    "services.homeIntro": "Bus, train, taxi, airport, pharmacies, medical help, emergency info, tourist help, weather and market days with official links for live updates.",
    "services.homeTitle": "Practical tourist info for Benalmádena",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
  es: {
    "actions.call": "Llamar",
    "actions.close": "Cerrar",
    "actions.directions": "Cómo llegar",
    "actions.exploreNearbyVenues": "Explorar locales cercanos",
    "actions.menu": "Menú",
    "actions.officialInfo": "Información oficial",
    "actions.viewAllServices": "Ver todos los servicios",
    "actions.viewVenue": "Ver local",
    "actions.website": "Sitio web",
    "common.loading": "Cargando...",
    "common.pageNotFound": "Página no encontrada",
    "footer.analytics": "Recopilamos datos de uso anónimos para mejorar Vibe2Nite. No vendemos datos personales identificables.",
    "footer.disclaimer": "Aviso legal",
    "footer.poweredBy": "Desarrollado por",
    "footer.privacy": "Privacidad",
    "footer.terms": "Términos",
    "hotel.barsNearby": "Bares cercanos",
    "hotel.beachBars": "Chiringuitos",
    "hotel.demoEyebrow": "Vista previa de demostración por Vibe2Nite",
    "hotel.familyFriendly": "Opciones para familias",
    "hotel.findTheVibe": "Encuentra el ambiente. Sal esta noche.",
    "hotel.liveMusicNightlife": "Música en vivo y vida nocturna",
    "hotel.nearbyRestaurants": "Restaurantes cercanos",
    "hotel.nightlife": "Vida nocturna",
    "hotel.travel.busOrTaxi": "Autobús o taxi recomendado desde {hotel}",
    "hotel.travel.notWalkable": "No recomendado a pie desde {hotel}",
    "hotel.travel.shortWalk": "Paseo corto desde {hotel}",
    "hotel.travel.taxiRecommended": "Taxi recomendado desde {hotel}",
    "hotel.travel.walkable": "Se puede ir andando desde {hotel}",
    "hotel.venuesCouldNotLoad": "No se pueden cargar los locales ahora mismo.",
    "hotel.vibe2nitePick": "Selección Vibe2Nite",
    "hotel.visitVibe2Nite": "Visitar Vibe2Nite",
    "language.label": "Idioma",
    "nav.awards": "Premios",
    "nav.destinations": "Destinos",
    "nav.food": "Comida",
    "nav.home": "Inicio",
    "nav.map": "Mapa",
    "nav.usefulServices": "Servicios útiles",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Aeropuerto",
    "services.bus": "Autobús",
    "services.emergency": "Emergencias",
    "services.markets": "Mercados",
    "services.medical": "Médico",
    "services.pharmacy": "Farmacia",
    "services.taxi": "Taxi",
    "services.tourist-info": "Turismo",
    "services.train": "Tren",
    "services.weather": "Tiempo",
    "services.homeEyebrow": "Servicios útiles",
    "services.homeIntro": "Autobús, tren, taxi, aeropuerto, farmacias, ayuda médica, emergencias, turismo, tiempo y mercados con enlaces oficiales.",
    "services.homeTitle": "Información práctica para turistas en Benalmádena",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
  fr: {
    "actions.call": "Appeler",
    "actions.close": "Fermer",
    "actions.directions": "Itinéraire",
    "actions.exploreNearbyVenues": "Explorer les lieux proches",
    "actions.menu": "Menu",
    "actions.officialInfo": "Information officielle",
    "actions.viewAllServices": "Voir tous les services",
    "actions.viewVenue": "Voir le lieu",
    "actions.website": "Site web",
    "common.loading": "Chargement...",
    "common.pageNotFound": "Page introuvable",
    "footer.analytics": "Nous collectons des données d'utilisation anonymes pour améliorer Vibe2Nite. Aucune donnée personnelle identifiable n'est vendue.",
    "footer.disclaimer": "Avertissement",
    "footer.poweredBy": "Propulsé par",
    "footer.privacy": "Confidentialité",
    "footer.terms": "Conditions",
    "hotel.barsNearby": "Bars à proximité",
    "hotel.beachBars": "Bars de plage",
    "hotel.demoEyebrow": "Aperçu démo par Vibe2Nite",
    "hotel.familyFriendly": "Options familiales",
    "hotel.findTheVibe": "Trouvez l'ambiance. Sortez ce soir.",
    "hotel.liveMusicNightlife": "Musique live et vie nocturne",
    "hotel.nearbyRestaurants": "Restaurants à proximité",
    "hotel.nightlife": "Vie nocturne",
    "hotel.travel.busOrTaxi": "Bus ou taxi recommandé depuis {hotel}",
    "hotel.travel.notWalkable": "Non recommandé à pied depuis {hotel}",
    "hotel.travel.shortWalk": "Courte marche depuis {hotel}",
    "hotel.travel.taxiRecommended": "Taxi recommandé depuis {hotel}",
    "hotel.travel.walkable": "Accessible à pied depuis {hotel}",
    "hotel.venuesCouldNotLoad": "Les lieux ne peuvent pas être chargés pour le moment.",
    "hotel.vibe2nitePick": "Choix Vibe2Nite",
    "hotel.visitVibe2Nite": "Visiter Vibe2Nite",
    "language.label": "Langue",
    "nav.awards": "Prix",
    "nav.destinations": "Destinations",
    "nav.food": "Restaurants",
    "nav.home": "Accueil",
    "nav.map": "Carte",
    "nav.usefulServices": "Services utiles",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Aéroport",
    "services.bus": "Bus",
    "services.emergency": "Urgence",
    "services.markets": "Marchés",
    "services.medical": "Médical",
    "services.pharmacy": "Pharmacie",
    "services.taxi": "Taxi",
    "services.tourist-info": "Tourisme",
    "services.train": "Train",
    "services.weather": "Météo",
    "services.homeEyebrow": "Services utiles",
    "services.homeIntro": "Bus, train, taxi, aéroport, pharmacies, aide médicale, urgence, tourisme, météo et marchés avec liens officiels.",
    "services.homeTitle": "Infos pratiques pour les visiteurs de Benalmádena",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
  de: {
    "actions.call": "Anrufen",
    "actions.close": "Schließen",
    "actions.directions": "Route",
    "actions.exploreNearbyVenues": "Orte in der Nähe entdecken",
    "actions.menu": "Menü",
    "actions.officialInfo": "Offizielle Info",
    "actions.viewAllServices": "Alle Services ansehen",
    "actions.viewVenue": "Ort ansehen",
    "actions.website": "Website",
    "common.loading": "Lädt...",
    "common.pageNotFound": "Seite nicht gefunden",
    "footer.analytics": "Wir erfassen anonyme Nutzungsdaten, um Vibe2Nite zu verbessern. Personenbezogene Daten werden nicht verkauft.",
    "footer.disclaimer": "Haftungsausschluss",
    "footer.poweredBy": "Bereitgestellt von",
    "footer.privacy": "Datenschutz",
    "footer.terms": "Bedingungen",
    "hotel.barsNearby": "Bars in der Nähe",
    "hotel.beachBars": "Strandbars",
    "hotel.demoEyebrow": "Demo-Vorschau von Vibe2Nite",
    "hotel.familyFriendly": "Familienfreundliche Optionen",
    "hotel.findTheVibe": "Finde die Stimmung. Geh heute Abend aus.",
    "hotel.liveMusicNightlife": "Live-Musik und Nachtleben",
    "hotel.nearbyRestaurants": "Restaurants in der Nähe",
    "hotel.nightlife": "Nachtleben",
    "hotel.travel.busOrTaxi": "Bus oder Taxi ab {hotel} empfohlen",
    "hotel.travel.notWalkable": "Zu Fuß ab {hotel} nicht empfohlen",
    "hotel.travel.shortWalk": "Kurzer Spaziergang ab {hotel}",
    "hotel.travel.taxiRecommended": "Taxi ab {hotel} empfohlen",
    "hotel.travel.walkable": "Zu Fuß ab {hotel} erreichbar",
    "hotel.venuesCouldNotLoad": "Orte können gerade nicht geladen werden.",
    "hotel.vibe2nitePick": "Vibe2Nite-Tipp",
    "hotel.visitVibe2Nite": "Vibe2Nite besuchen",
    "language.label": "Sprache",
    "nav.awards": "Awards",
    "nav.destinations": "Reiseziele",
    "nav.food": "Essen",
    "nav.home": "Start",
    "nav.map": "Karte",
    "nav.usefulServices": "Nützliche Services",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Flughafen",
    "services.bus": "Bus",
    "services.emergency": "Notfall",
    "services.markets": "Märkte",
    "services.medical": "Medizin",
    "services.pharmacy": "Apotheke",
    "services.taxi": "Taxi",
    "services.tourist-info": "Tourismus",
    "services.train": "Zug",
    "services.weather": "Wetter",
    "services.homeEyebrow": "Nützliche Services",
    "services.homeIntro": "Bus, Zug, Taxi, Flughafen, Apotheken, medizinische Hilfe, Notfallinfos, Tourismus, Wetter und Märkte mit offiziellen Links.",
    "services.homeTitle": "Praktische Besucherinfos für Benalmádena",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
  nl: {
    "actions.call": "Bellen",
    "actions.close": "Sluiten",
    "actions.directions": "Route",
    "actions.exploreNearbyVenues": "Ontdek plekken in de buurt",
    "actions.menu": "Menu",
    "actions.officialInfo": "Officiële info",
    "actions.viewAllServices": "Alle services bekijken",
    "actions.viewVenue": "Bekijk locatie",
    "actions.website": "Website",
    "common.loading": "Laden...",
    "common.pageNotFound": "Pagina niet gevonden",
    "footer.analytics": "We verzamelen anonieme gebruiksgegevens om Vibe2Nite te verbeteren. Persoonlijk identificeerbare gegevens worden niet verkocht.",
    "footer.disclaimer": "Disclaimer",
    "footer.poweredBy": "Mogelijk gemaakt door",
    "footer.privacy": "Privacy",
    "footer.terms": "Voorwaarden",
    "hotel.barsNearby": "Bars in de buurt",
    "hotel.beachBars": "Strandbars",
    "hotel.demoEyebrow": "Demo preview door Vibe2Nite",
    "hotel.familyFriendly": "Gezinsvriendelijke opties",
    "hotel.findTheVibe": "Vind de vibe. Ga vanavond.",
    "hotel.liveMusicNightlife": "Livemuziek en nachtleven",
    "hotel.nearbyRestaurants": "Restaurants in de buurt",
    "hotel.nightlife": "Nachtleven",
    "hotel.travel.busOrTaxi": "Bus of taxi aanbevolen vanaf {hotel}",
    "hotel.travel.notWalkable": "Niet aanbevolen te voet vanaf {hotel}",
    "hotel.travel.shortWalk": "Korte wandeling vanaf {hotel}",
    "hotel.travel.taxiRecommended": "Taxi aanbevolen vanaf {hotel}",
    "hotel.travel.walkable": "Te voet bereikbaar vanaf {hotel}",
    "hotel.venuesCouldNotLoad": "Locaties kunnen nu niet worden geladen.",
    "hotel.vibe2nitePick": "Vibe2Nite-keuze",
    "hotel.visitVibe2Nite": "Bezoek Vibe2Nite",
    "language.label": "Taal",
    "nav.awards": "Awards",
    "nav.destinations": "Bestemmingen",
    "nav.food": "Eten",
    "nav.home": "Home",
    "nav.map": "Map",
    "nav.usefulServices": "Handige services",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Luchthaven",
    "services.bus": "Bus",
    "services.emergency": "Noodhulp",
    "services.markets": "Markten",
    "services.medical": "Medisch",
    "services.pharmacy": "Apotheek",
    "services.taxi": "Taxi",
    "services.tourist-info": "Toerisme",
    "services.train": "Trein",
    "services.weather": "Weer",
    "services.homeEyebrow": "Handige services",
    "services.homeIntro": "Bus, trein, taxi, luchthaven, apotheken, medische hulp, noodinfo, toerisme, weer en marktdagen met officiële links.",
    "services.homeTitle": "Praktische toeristeninfo voor Benalmádena",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
  pl: {
    "actions.call": "Zadzwoń",
    "actions.close": "Zamknij",
    "actions.directions": "Trasa",
    "actions.exploreNearbyVenues": "Zobacz miejsca w pobliżu",
    "actions.menu": "Menu",
    "actions.officialInfo": "Informacje oficjalne",
    "actions.viewAllServices": "Zobacz wszystkie usługi",
    "actions.viewVenue": "Zobacz miejsce",
    "actions.website": "Strona www",
    "common.loading": "Ładowanie...",
    "common.pageNotFound": "Nie znaleziono strony",
    "footer.analytics": "Zbieramy anonimowe dane użytkowania, aby ulepszać Vibe2Nite. Nie sprzedajemy danych osobowych umożliwiających identyfikację.",
    "footer.disclaimer": "Zastrzeżenie",
    "footer.poweredBy": "Obsługiwane przez",
    "footer.privacy": "Prywatność",
    "footer.terms": "Warunki",
    "hotel.barsNearby": "Bary w pobliżu",
    "hotel.beachBars": "Bary plażowe",
    "hotel.demoEyebrow": "Podgląd demo od Vibe2Nite",
    "hotel.familyFriendly": "Opcje dla rodzin",
    "hotel.findTheVibe": "Znajdź klimat. Wyjdź dziś wieczorem.",
    "hotel.liveMusicNightlife": "Muzyka na żywo i życie nocne",
    "hotel.nearbyRestaurants": "Restauracje w pobliżu",
    "hotel.nightlife": "Życie nocne",
    "hotel.travel.busOrTaxi": "Zalecany autobus lub taxi z {hotel}",
    "hotel.travel.notWalkable": "Nie zalecamy pieszo z {hotel}",
    "hotel.travel.shortWalk": "Krótki spacer z {hotel}",
    "hotel.travel.taxiRecommended": "Zalecane taxi z {hotel}",
    "hotel.travel.walkable": "Można dojść pieszo z {hotel}",
    "hotel.venuesCouldNotLoad": "Nie można teraz załadować miejsc.",
    "hotel.vibe2nitePick": "Wybór Vibe2Nite",
    "hotel.visitVibe2Nite": "Odwiedź Vibe2Nite",
    "language.label": "Język",
    "nav.awards": "Nagrody",
    "nav.destinations": "Kierunki",
    "nav.food": "Jedzenie",
    "nav.home": "Start",
    "nav.map": "Mapa",
    "nav.usefulServices": "Przydatne usługi",
    "nav.vibePass": "Vibe Pass",
    "services.airport": "Lotnisko",
    "services.bus": "Autobus",
    "services.emergency": "Pomoc nagła",
    "services.markets": "Targi",
    "services.medical": "Medyczna",
    "services.pharmacy": "Apteka",
    "services.taxi": "Taxi",
    "services.tourist-info": "Turystyka",
    "services.train": "Pociąg",
    "services.weather": "Pogoda",
    "services.homeEyebrow": "Przydatne usługi",
    "services.homeIntro": "Autobus, pociąg, taxi, lotnisko, apteki, pomoc medyczna, nagła pomoc, turystyka, pogoda i targi z oficjalnymi linkami.",
    "services.homeTitle": "Praktyczne informacje turystyczne dla Benalmádeny",
    "vibePass.engagementPoints": "Vibe2Nite Points",
    "vibePass.trustedPoints": "Vibe Pass Points",
  },
};
